import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Container, Nav, Navbar } from "react-bootstrap";

import header from "../../../assets/images/header.svg";
import { routes } from "../../../Router";

export default function NavBar(props: {
  isLoading?: boolean;
  bgTransparent?: boolean;
  previousPath?: string;
}): React.JSX.Element {
  /**
   * The top navbar with Bridgegap logo.
   */
  const location = useLocation();

  const hideButtons: boolean = [routes.root, routes.login].includes(
    location.pathname,
  );

  const menuButtonWidth = "2.4rem";

  return (
    <Navbar
      expand={false}
      className={`py-0 ${props.bgTransparent ? "bg-transparent" : "bg-white"}`}
    >
      <Container fluid={true} className="g-0">
        <div className="w-100 h-100 d-flex align-items-center justify-content-between flex-nowrap">
          <div style={{ width: menuButtonWidth }} />
          <Navbar.Brand className="h-100 py-0 m-0 d-flex align-items-center justify-content-center">
            <img
              alt="Bridgegap logo"
              title="Bridgegap logo"
              src={header}
              className="img-fluid my-2"
              style={{ height: "2rem", maxHeight: "2rem" }}
            />
          </Navbar.Brand>
          {!hideButtons && !props.isLoading ? (
            <Navbar.Toggle
              aria-controls="navbar-nav"
              className="border-0 rounded-0 p-1"
              style={{ width: menuButtonWidth }}
            />
          ) : (
            <div style={{ width: menuButtonWidth }} />
          )}
        </div>
        <Navbar.Collapse id="navbar-nav" className="text-end">
          <Nav className="gap-2 pt-2">
            <Nav.Item>
              <Link to={routes.root} className="link-dark h5">
                Home
              </Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
